<template>
  <el-tooltip :content="attr.value" placement="top-end" effect="light">
    <!-- content to trigger tooltip here -->
    <div class="attr-item" :class="{actived, disable}" @click="onClick">
      <img v-if="showImg" class="w-8 h-8" :src="joinHead(attr.src)" alt="">
      <template v-else>
        {{ attr.value }}
      </template>
    </div>
  </el-tooltip>

</template>

<script>
export default {
  props: {
    attr: {
      type: Object,
      default() {
        return {}
      }
    },

    showImg: {
      type: Boolean,
      default: false
    },

    actived: {
      type: Boolean,
      default: false
    },

    disable: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick() {
      if (!this.disable) {
        this.$emit('click')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.attr-item {
  @apply py-2 px-4 bg-gray-200 rounded-sm cursor-pointer select-none leading-6;
  &:hover, &.actived {
    @apply bg-primary text-white;
  }

  &.disable {
    @apply opacity-60 cursor-not-allowed;
  }
}
</style>
